<template>
    <div class="services">
        <div class="row">
            <div class="col-12 services-div">
                <div class="listed-services justify-content-center d-flex flex-column">
                    <h6 class="headline">Services</h6>
                    <h2 class="service-description">We’re here to answer your tax, payroll and business related questions
                        and help
                        you with your tax
                        filing requirements.</h2>
                    <div class="row text-white service-list">
                        <div class="col-lg-4 col-12">
                            <h3 class="text-center"><i class="fa-solid fa-person"></i>&nbsp; Individual Tax
                                Returns</h3>
                            <p class="text-center">Individual tax returns are documents filed by taxpayers, such as
                                employees, freelancers, and
                                self-employed individuals, to report income, calculate taxes owed or refunds due, and
                                fulfill their tax obligations.
                            </p>

                            <ul class="price-list">
                                <li><b>Form 1040 (Standard)</b></li>
                                <li><b>Form 1040 (With Schedule A - Itemized Deductions)</b></li>
                                <li><b>Form 1040 (With Schedule C - Self-Employment)</b></li>
                                <li><b>Form 1040 (With Schedule D - Capital Gains/Losses)</b></li>
                                <li><b>Form 1040 (With Additional Forms)</b></li>
                            </ul>

                        </div>
                        <div class="col-lg-4 col-12">
                            <h3 class="text-center"><i class="fa-solid fa-pen-to-square"></i>&nbsp; Amended Tax
                                Return</h3>
                            <p class="text-center">An amended tax return is a form filed by taxpayers to correct errors or
                                update information on
                                a previously submitted tax return to accurately reflect income, deductions, credits, or
                                filing status.
                            </p>
                            <ul class="price-list">
                                <li><b>(Form 1040X)</b></li>
                            </ul>

                        </div>
                        <div class="col-lg-4 col-12">
                            <h3 class="text-center"><i class="fa-solid fa-people-group"></i>&nbsp; State Tax
                                Return</h3>
                            <p class="text-lg-left text-center">A state tax return is a document filed by individuals or
                                businesses with
                                their state
                                government to report income, calculate state taxes owed or refunds due, and comply with
                                state tax laws.
                            </p>
                        </div>
                        <div class="col-12 d-flex justify-content-center">
                            <a class="router-link-appointment-services" href="http://booking.sowellprepared.org">
                                Make An Appointment
                            </a>
                        </div>
                        <div class="col-1 col-lg-3"></div>
                        <div class="col-10 col-lg-6">
                            <h6 class="headline text-center"><b>Discounts</b></h6>
                            <ul>
                                <li><b>Early Filing Discount:</b> 10% off for returns filed by March 1.</li>
                                <li><b>Referral Discount</b>: $25 off for each new client referred.</li>
                            </ul>
                            <h6 class="headline text-center"><b>Disclaimer</b></h6>
                            <ul>
                                <li>Prices may vary depending on complexity and specific client needs.</li>
                                <li>A consultation fee may apply for initial discussions, which can be credited toward
                                    the preparation fee if services are rendered.</li>
                            </ul>
                        </div>
                        <div class="col-1 col-lg-3"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="contact">
        <ContactView></ContactView>
    </div>
</template>

<script>
import ContactView from '@/views/ContactView.vue'

export default {
    name: 'ServicesView',
    components: {
        ContactView
    }
}
</script>

<style>
.services {
    background-color: rgba(0, 0, 0, 0.15);
    padding: 25px 0
}

#contact {
    background-color: rgba(0, 0, 0, 0.25);
}

.services-div {
    padding: 0 7.5%
}

.headline {
    color: white;
    font-size: 1.35rem;
    text-align: center
}

.service-description {
    color: #f5f2f2;
    text-align: center;
    letter-spacing: 0.5px;
    margin-bottom: 3rem
}

.listed-services {
    background: #66b2ff;
    padding: 20px;
    border-radius: 15px
}

.service-list {
    margin-bottom: 3.5rem
}

.service-list div {
    padding: 0 2.5%
}

.router-link-appointment-services {
    background: #ff99cc;
    color: white;
    text-decoration: none;
    padding: 0.5rem;
    font-size: 1.25rem;
    border-radius: 7.5px;
    width: 33.3% !important;
    text-align: center
}

.headline {
    margin-top: 1.15rem
}

@media(max-width: 1400px) and (min-width: 1200px) {
    .service-description {
        font-size: 1.25rem;
    }

    .listed-services p {
        font-size: 1rem;
    }

    .headline {
        font-size: 1.05rem;
        margin-top: 1.25rem;
    }

    .listed-services h3 {
        font-size: 1.4rem
    }

    .router-link-appointment-services {
        padding: 0.25rem;
        font-size: 1.15rem;
        border-radius: 5px;
        width: 33.3% !important;
        margin-bottom: 0;
    }
}

@media(max-width: 1200px) and (min-width: 992px) {
    .service-description {
        font-size: 1.2rem;
    }

    .listed-services p {
        font-size: 0.9rem;
    }

    .headline {
        font-size: 1rem;
        margin-top: 1.15rem;
    }

    .listed-services h3 {
        font-size: 1.3rem
    }

    .router-link-appointment-services {
        padding: 0.2rem;
        font-size: 1.1rem;
        border-radius: 5px;
        width: 33.3% !important;
        margin-bottom: 0;
    }
}

@media(max-width: 992px) and (min-width: 768px) {
    .price-list {
        margin-left: 10%
    }

    .service-description {
        font-size: 1.2rem;
    }

    .listed-services p,
    ul li {
        font-size: 0.9rem;
    }

    .headline {
        font-size: 1rem;
        margin-top: 1.15rem;
    }

    .listed-services h3 {
        font-size: 1.3rem
    }

    .router-link-appointment-services {
        padding: 0.2rem;
        font-size: 1.1rem;
        border-radius: 5px;
        width: 33.3% !important;
        margin-bottom: 0;
    }
}

@media(max-width: 768px) and (min-width: 576px) {
    .price-list {
        margin-left: 7.5%
    }

    .service-description {
        font-size: 1.15rem;
    }

    .listed-services p,
    ul li {
        font-size: 1rem;
    }

    .headline {
        font-size: 1.05rem;
        margin-top: 1.1rem;
    }

    .listed-services h3 {
        font-size: 1.3rem
    }

    .router-link-appointment-services {
        padding: 0.15rem;
        font-size: 1.1rem;
        border-radius: 5px;
        width: 40% !important;
        margin-bottom: 0;
    }
}

@media(max-width: 576px) and (min-width: 420px) {
    .price-list {
        margin-left: 4%
    }

    .service-description {
        font-size: 1.15rem;
    }

    .listed-services p,
    ul li {
        font-size: 1.1rem;
    }

    .headline {
        font-size: 1.15rem;
        margin-top: 0.85rem;
    }

    .listed-services h3 {
        font-size: 1.25rem
    }

    .router-link-appointment-services {
        padding: 0.2rem;
        font-size: 1.2rem;
        border-radius: 5px;
        width: 70% !important;
        margin-bottom: 0;
    }
}

@media(max-width: 420px) and (min-width: 360px) {
    .price-list {
        margin-left: 1.5%
    }

    .service-description {
        font-size: 1.05rem;
        margin-bottom: 1rem;
    }

    .listed-services p,
    ul li {
        font-size: 0.925rem;
    }

    .headline {
        font-size: 0.975rem;
        margin-top: 0.85rem;
    }

    .listed-services h3 {
        font-size: 1.175rem
    }

    .router-link-appointment-services {
        padding: 0.15rem;
        font-size: 1.1rem;
        border-radius: 5px;
        width: 75% !important;
        margin-bottom: 0;
    }
}

@media(max-width: 360px) {
    .price-list {
        margin-left: 1%
    }

    .service-description {
        font-size: 1rem;
        margin-bottom: 1.2rem;
    }

    .listed-services p,
    ul li {
        font-size: 0.8rem;
    }

    .headline {
        font-size: 0.9rem;
        margin-top: 0.8rem;
    }

    .listed-services h3 {
        font-size: 1.1rem
    }

    .router-link-appointment-services {
        padding: 0.1rem;
        font-size: 1rem;
        border-radius: 5px;
        width: 80% !important;
        margin-bottom: 0;
    }
}
</style>